import type { FaireProductEntity } from "../../entity_types/product";

export const p_hruxhwpetx: FaireProductEntity = {
  token: "p_hruxhwpetx",
  type: "product",
  name: "Crazy Banana",
  brandToken: "b_mukk4ka83q",
  brandName: "The Penny Candy Store",
  imageUrl:
    "https://cdn.faire.com/fastly/9ca0395e9b037754482044ed225c7a737ddf2acc6a1fbef37e8292c9fab2db97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27fa421cc74c5b798e0bda6486c5585cb974ced99947c05960aa24d05adb725e.jpeg",
  ],
  priceDollars: 2.29,
  description:
    "Relish in Crazy Banana, a Hard Candy from The Penny Candy Store. Using recyclable packaging, these candies balance tradition and sustainability, promising a 12-24 month shelf life.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:07.422Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
